import React from "react";
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner'
import Form from 'react-bootstrap/Form';
import { CorgEntity } from "./CorgEntity";
import useApi from "../../../lib/apiService";

function OemLookup() {
    const Api = useApi();
    const [showLookup, setShowLookup] = React.useState(false);
    const [showSpinner, setShowSpinner] = React.useState(false);
    const [oemIdInput, setOemIdInput] = React.useState(""); 
    const [oemId, setOemId] = React.useState(null);
    const [dealerData, setDealerData] = React.useState(null);

    React.useEffect(() => {
      (async() => {
        if (oemId) {
          setDealerData(null);
          setShowSpinner(true);
          try {
            let dealer = await Api.oemLookup(oemId);
            if (dealer) {
              setDealerData(dealer);
            } else {
              alert("Dealer not found");
            }          
          } catch (e) {
            alert(e);
          }
          setShowSpinner(false);
        }
      })();
    }, [oemId]);

    const handleSearch = (e) => {
        if (e) e.preventDefault();
        setOemId(oemIdInput);
    }

    return <>
    <Button variant="outline-secondary" size="sm" className="me-2" onClick={() => setShowLookup(true)} id="oem-lookup-button">OEM Lookup</Button>
    <Modal centered size="lg" show={showLookup} onHide={() => setShowLookup(false)}>
    <Modal.Header closeButton>
      <Modal.Title>OEM Lookup Tool</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Form onSubmit={handleSearch}>
        <Form.Group className="d-flex align-items-center mb-3">
          <Form.Label className="me-2 mb-0">OEM&nbsp;Id</Form.Label>
          <Form.Control 
            type="text" 
            placeholder="Ford paCode, etc.." 
            value={oemIdInput} 
            onChange={(e) => setOemIdInput(e.target.value)}
            className="me-2"
            id="oem-id-input"
          />
          <Button type="submit" id="oem-search-button">Search</Button>
        </Form.Group>
      </Form>

      <div style={{margin: "8px"}}>
      {showSpinner && <Spinner animation="border" />}
      {dealerData && dealerData.map((x) => <CorgEntity key={x.commonOrgId} obj={x} setShowLookup={setShowLookup}></CorgEntity>)}
      </div>

    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={() => setShowLookup(false)}>Close</Button>
    </Modal.Footer>
  </Modal>
  </>
}

export default OemLookup;
